// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zEqX","productName":"Table_productName__pZsIT"};